/* 4S Kleedkamer: shirtrek om door te bladeren. Geen afhankelijkheden.
   Weergave 'rek' (3-11-2026): shirts dicht op elkaar aan een stang, met de zijkant naar je toe;
   het gekozen shirt komt naar voren en draait naar je toe. Weergave 'lijsten': de oude carrousel.
   Versie 2 (3-11-2026): dieper 3D, het rek kantelt mee met de muis, en de witte achtergrond van
   de productfoto wordt weggeknipt (alleen als de rand van de foto echt wit is).
   Versie 3 (3-11-2026): beter knippen. Alleen puur wit is achtergrond (witte shirts blijven heel),
   witte randjes en spikkels gaan weg, schaduw op de achtergrond wordt gevolgd en de rand is glad.
   75 shirts per rek (3-11-2026): alleen shirts rond het gekozen shirt worden geladen en uitgeknipt. */
(function () {
  if (customElements.get('s4-kleedkamer')) return;

  class S4Kleedkamer extends HTMLElement {
    connectedCallback() {
      this.rekModus = this.dataset.weergave === 'rek';
      this.rekken = Array.from(this.querySelectorAll('[data-rek-paneel]'));
      this.chips = Array.from(this.querySelectorAll('[data-rek]'));
      this.actief = 0;
      this.pos = this.rekken.map(function () { return 0; });
      this.smal = window.matchMedia('(max-width: 749px)');
      this.middel = window.matchMedia('(max-width: 989px)');

      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.kiesRek(Number(chip.dataset.rek)));
      });

      this.rekken.forEach((rek, r) => {
        const items = Array.from(rek.querySelectorAll('.s4-kk__item'));
        items.forEach((item, i) => {
          item.addEventListener('click', () => {
            if (this.geveegd) { this.geveegd = false; return; }
            if (this.pos[r] === i) { window.location.href = item.dataset.url; return; }
            this.zet(r, i);
          });
        });
        const vorige = rek.querySelector('[data-vorige]');
        const volgende = rek.querySelector('[data-volgende]');
        if (vorige) vorige.addEventListener('click', (e) => { e.stopPropagation(); this.zet(r, this.pos[r] - 1); });
        if (volgende) volgende.addEventListener('click', (e) => { e.stopPropagation(); this.zet(r, this.pos[r] + 1); });
        rek.addEventListener('keydown', (e) => {
          if (e.target !== rek) return;
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.zet(r, this.pos[r] - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.zet(r, this.pos[r] + 1); }
          if (e.key === 'Enter' && items[this.pos[r]]) { window.location.href = items[this.pos[r]].dataset.url; }
        });

        /* Slepen of vegen: in de rek-weergave schuift het rek mee met je vinger of muis. */
        let startX = null;
        let startPos = 0;
        let bewogen = false;
        rek.addEventListener('pointerdown', (e) => {
          if (e.button !== undefined && e.button !== 0) return;
          startX = e.clientX; startPos = this.pos[r]; bewogen = false;
        });
        rek.addEventListener('pointermove', (e) => {
          if (startX === null || !this.rekModus) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) < 12) return;
          bewogen = true;
          const stap = this.smal.matches ? 34 : 46;
          const doel = startPos - Math.round(dx / stap);
          if (doel !== this.pos[r]) this.zet(r, doel, false, true);
        });
        const einde = (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (this.rekModus) {
            if (bewogen) { this.geveegd = true; setTimeout(() => { this.geveegd = false; }, 350); }
            return;
          }
          if (Math.abs(dx) > 40) { this.geveegd = true; this.zet(r, this.pos[r] + (dx < 0 ? 1 : -1)); setTimeout(() => { this.geveegd = false; }, 350); }
        };
        rek.addEventListener('pointerup', einde);
        rek.addEventListener('pointercancel', () => { startX = null; });
        rek.addEventListener('pointerleave', (e) => { if (startX !== null && e.pointerType === 'mouse') einde(e); });

        /* Opzij scrollen met trackpad of muis (horizontaal), zoals door een echt rek gaan. */
        if (this.rekModus) {
          let opgeteld = 0;
          let wacht = false;
          rek.addEventListener('wheel', (e) => {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            e.preventDefault();
            opgeteld += e.deltaX;
            if (wacht) return;
            if (Math.abs(opgeteld) > 40) {
              this.zet(r, this.pos[r] + (opgeteld > 0 ? 1 : -1));
              opgeteld = 0; wacht = true;
              setTimeout(() => { wacht = false; }, 90);
            }
          }, { passive: false });
        }

        const midden = this.rekModus ? Math.min(Math.floor(items.length / 2), 6) : Math.min(Math.floor(items.length / 2), 3);
        this.zet(r, midden, true);
        if (this.rekModus) this.kantel(rek);
      });
      const her = () => this.rekken.forEach((rek, r) => this.zet(r, this.pos[r], true));
      if (this.smal.addEventListener) { this.smal.addEventListener('change', her); this.middel.addEventListener('change', her); }
      this.toonInfo();
      this.startAuto();
    }

    startAuto() {
      const ms = Number(this.dataset.auto || 0);
      if (!ms || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.hover = false;
      this.handmatig = false;
      let zichtbaar = true;
      this.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') this.hover = true; });
      this.addEventListener('pointerleave', () => { this.hover = false; });
      this.addEventListener('focusin', (e) => { if (!e.target.matches('[data-pauze]')) this.hover = true; });
      this.addEventListener('focusout', () => { this.hover = false; });
      this.addEventListener('touchstart', () => {
        this.hover = true;
        clearTimeout(this.hervat);
        this.hervat = setTimeout(() => { this.hover = false; }, 8000);
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((e) => { zichtbaar = e[0].isIntersecting; }).observe(this);
      }
      const knop = this.querySelectorAll('[data-pauze]');
      knop.forEach((k) => k.addEventListener('click', (e) => {
        e.stopPropagation();
        this.handmatig = !this.handmatig;
        knop.forEach((b) => {
          b.setAttribute('aria-pressed', this.handmatig ? 'true' : 'false');
          b.setAttribute('aria-label', this.handmatig ? 'Automatisch bladeren hervatten' : 'Automatisch bladeren pauzeren');
          b.innerHTML = this.handmatig ? '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5 3l8 5-8 5z" fill="currentColor"/></svg>' : '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M5 3v10M11 3v10" stroke="currentColor" stroke-width="2" fill="none"/></svg>';
        });
      }));
      setInterval(() => {
        if (this.hover || this.handmatig || !zichtbaar || document.hidden) return;
        this.zet(this.actief, this.pos[this.actief] + 1);
      }, ms);
    }

    kiesRek(r) {
      this.actief = r;
      this.rekken.forEach((rek, k) => { rek.hidden = k !== r; });
      this.chips.forEach((chip, k) => chip.setAttribute('aria-pressed', k === r ? 'true' : 'false'));
      this.zet(r, this.pos[r], true);
      this.toonInfo();
    }

    /* Plaats van elk shirt in de rek-weergave. off = afstand tot het gekozen shirt. */
    rekStand(off) {
      const smal = this.smal.matches;
      const naastPaneel = !this.middel.matches;
      const a = Math.abs(off);
      const kant = off < 0 ? -1 : 1;
      const basis = naastPaneel ? -170 : 0;             /* ruimte voor het glazen paneel rechts */
      if (off === 0) {
        return { x: basis, z: smal ? 140 : 230, ry: 0, s: 1, o: 1, zi: 200, b: 1 };
      }
      const eerste = smal ? 132 : 215;                  /* van het midden naar het eerste zijshirt */
      const stap = smal ? 24 : 34;                      /* zo dicht hangen ze op elkaar */
      const x = basis + kant * (eerste + (a - 1) * stap);
      const zicht = smal ? 8 : (naastPaneel ? 13 : 16);
      return {
        x: x,
        z: -30 - a * 5,
        ry: kant * -80,                                 /* zijkant naar je toe, voorkant naar het midden */
        s: 0.94,
        o: a > zicht ? 0 : Math.max(0.3, 1 - a * 0.045),
        zi: 150 - a,
        b: Math.max(0.42, 0.82 - a * 0.03)
      };
    }

    /* Het rek kantelt een beetje mee met de muis, zoals een camera in de kleedkamer. */
    kantel(rek) {
      const scene = rek.querySelector('.s4-kk__scene');
      if (!scene || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      rek.addEventListener('pointermove', (e) => {
        if (e.pointerType !== 'mouse') return;
        const b = rek.getBoundingClientRect();
        const px = (e.clientX - b.left) / b.width - 0.5;
        const py = (e.clientY - b.top) / b.height - 0.5;
        scene.style.transform = 'rotateX(' + (-2 + py * -4).toFixed(2) + 'deg) rotateY(' + (px * 7).toFixed(2) + 'deg)';
      });
      rek.addEventListener('pointerleave', () => { scene.style.transform = ''; });
    }

    /* Witte achtergrond van de productfoto wegknippen, zodat het shirt zelf aan de hanger hangt.
       Alleen als de rand van de foto (bijna) helemaal wit is. Anders blijft de witte kaart.
       Alleen de shirts rond het gekozen shirt (die in beeld hangen), zodat 75 shirts per rek
       niet allemaal tegelijk laden. */
    knipRond(r, i) {
      if (!this.rekModus || !window.HTMLCanvasElement || r !== this.actief) return;
      const items = this.rekken[r].querySelectorAll('.s4-kk__item');
      items.forEach((item, k) => {
        if (Math.abs(k - i) > 18) return;
        const img = item.querySelector('.s4-kk__shirt img');
        if (!img || img.dataset.knip) return;
        img.dataset.knip = '1';
        const start = () => {
          const doe = () => this.knip(img);
          if ('requestIdleCallback' in window) window.requestIdleCallback(doe, { timeout: 1500 }); else setTimeout(doe, 60);
        };
        if (img.complete && img.naturalWidth) start(); else img.addEventListener('load', start, { once: true });
        img.loading = 'eager';
      });
    }

    knip(img) {
      const bron = img.currentSrc || img.src;
      if (!bron) return;
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = () => {
        try {
          const W = Math.min(560, im.naturalWidth || 560);
          const H = Math.round((im.naturalHeight || 700) * W / (im.naturalWidth || 560));
          const c = document.createElement('canvas');
          c.width = W; c.height = H;
          const x = c.getContext('2d', { willReadFrequently: true });
          x.drawImage(im, 0, 0, W, H);
          const d = x.getImageData(0, 0, W, H);
          const p = d.data;
          const N = W * H;
          const mn = new Uint8Array(N);   /* donkerste kanaal: hoe wit is de pixel */
          const sp = new Uint8Array(N);   /* verschil tussen kanalen: hoe grijs/kleurloos */
          for (let k = 0; k < N; k++) {
            const r = p[k * 4], g = p[k * 4 + 1], b = p[k * 4 + 2];
            const lo = Math.min(r, g, b);
            mn[k] = lo; sp[k] = Math.max(r, g, b) - lo;
          }
          const gl = new Float32Array(N); /* licht vervaagd, voor het volgen van schaduw */
          for (let y = 0; y < H; y++) for (let X = 0; X < W; X++) {
            let s = 0, t = 0;
            for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
              const a = X + dx, b = y + dy;
              if (a < 0 || b < 0 || a >= W || b >= H) continue;
              s += mn[b * W + a]; t++;
            }
            gl[y * W + X] = s / t;
          }
          /* alleen echt wit telt als achtergrond, zodat witte shirts heel blijven */
          const wit = (k) => mn[k] >= 250 && sp[k] < 10;
          const zijde = (lijst) => lijst.filter(wit).length / lijst.length;
          const boven = [], onder = [], links = [], rechts = [];
          for (let i = 0; i < W; i++) { boven.push(i); onder.push((H - 1) * W + i); }
          for (let j = 0; j < H; j++) { links.push(j * W); rechts.push(j * W + W - 1); }
          if ([boven, onder, links, rechts].map(zijde).filter((v) => v > 0.85).length < 3) return; /* geen witte foto */
          const weg = new Uint8Array(N);
          const stapel = [];
          const duw = (k) => { if (!weg[k] && wit(k)) { weg[k] = 1; stapel.push(k); } };
          for (let s = 0; s < 4; s++) {
            for (let i = 0; i < W; i++) { duw(s * W + i); duw((H - 1 - s) * W + i); }
            for (let j = 0; j < H; j++) { duw(j * W + s); duw(j * W + W - 1 - s); }
          }
          for (let s = 0; s < 3; s++) {   /* een grijze randlijn van de foto altijd weg */
            for (let i = 0; i < W; i++) { weg[s * W + i] = 1; weg[(H - 1 - s) * W + i] = 1; }
            for (let j = 0; j < H; j++) { weg[j * W + s] = 1; weg[j * W + W - 1 - s] = 1; }
          }
          while (stapel.length) {
            const k = stapel.pop();
            const kx = k % W, ky = (k / W) | 0;
            if (kx > 0) duw(k - 1);
            if (kx < W - 1) duw(k + 1);
            if (ky > 0) duw(k - W);
            if (ky < H - 1) duw(k + W);
          }
          /* schaduw op de achtergrond: een zachte grijze overgang volgen */
          const st2 = [];
          for (let k = 0; k < N; k++) if (weg[k]) st2.push(k);
          while (st2.length) {
            const k = st2.pop();
            const kx = k % W, ky = (k / W) | 0;
            const nb = [];
            if (kx > 0) nb.push(k - 1);
            if (kx < W - 1) nb.push(k + 1);
            if (ky > 0) nb.push(k - W);
            if (ky < H - 1) nb.push(k + W);
            for (const q of nb) {
              if (!weg[q] && sp[q] < 12 && mn[q] >= 110 && Math.abs(gl[q] - gl[k]) <= 1.5) { weg[q] = 1; st2.push(q); }
            }
          }
          let n = 0;
          for (let k = 0; k < N; k++) if (weg[k]) n++;
          const deel = n / N;
          if (deel < 0.1 || deel > 0.9) return;   /* geen duidelijk shirt gevonden: niets doen */
          const buren = (k) => {
            const kx = k % W, ky = (k / W) | 0;
            let t = 0;
            for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
              if (!dx && !dy) continue;
              const X = kx + dx, Y = ky + dy;
              if (X < 0 || Y < 0 || X >= W || Y >= H || weg[Y * W + X]) t++;
            }
            return t;
          };
          /* witte rand (halo) laag voor laag weghalen, hooguit 3 pixels diep */
          for (let laag = 0; laag < 3; laag++) {
            const nu = [];
            for (let k = 0; k < N; k++) if (!weg[k] && mn[k] >= 212 && sp[k] < 22 && buren(k) >= 2) nu.push(k);
            nu.forEach((k) => { weg[k] = 1; });
          }
          /* losse spikkels die bijna helemaal door achtergrond omringd zijn */
          for (let r = 0; r < 2; r++) {
            const nu = [];
            for (let k = 0; k < N; k++) if (!weg[k] && buren(k) >= 6) nu.push(k);
            nu.forEach((k) => { weg[k] = 1; });
          }
          /* rafels gladmaken: 2 pixels krimpen en weer groeien */
          const rand = (k, binnen) => {
            const kx = k % W, ky = (k / W) | 0;
            const v = binnen ? 1 : 0;
            return (kx > 0 && weg[k - 1] === v) || (kx < W - 1 && weg[k + 1] === v) || (ky > 0 && weg[k - W] === v) || (ky < H - 1 && weg[k + W] === v);
          };
          for (let it = 0; it < 2; it++) { const nu = []; for (let k = 0; k < N; k++) if (!weg[k] && rand(k, true)) nu.push(k); nu.forEach((k) => { weg[k] = 1; }); }
          for (let it = 0; it < 2; it++) { const nu = []; for (let k = 0; k < N; k++) if (weg[k] && rand(k, false)) nu.push(k); nu.forEach((k) => { weg[k] = 0; }); }
          /* eilandjes kleiner dan 40 pixels weg */
          const lab = new Uint8Array(N);
          for (let k = 0; k < N; k++) {
            if (weg[k] || lab[k]) continue;
            const s = [k], lijst = [k];
            lab[k] = 1;
            while (s.length) {
              const q = s.pop();
              const qx = q % W, qy = (q / W) | 0;
              const nb = [];
              if (qx > 0) nb.push(q - 1);
              if (qx < W - 1) nb.push(q + 1);
              if (qy > 0) nb.push(q - W);
              if (qy < H - 1) nb.push(q + W);
              for (const r of nb) if (!weg[r] && !lab[r]) { lab[r] = 1; s.push(r); lijst.push(r); }
            }
            if (lijst.length < 40) lijst.forEach((q) => { weg[q] = 1; });
          }
          /* zachte rand: hoe witter en hoe meer achtergrond eromheen, hoe doorzichtiger */
          let x0 = W, y0 = H, x1 = 0, y1 = 0;
          for (let k = 0; k < N; k++) {
            if (weg[k]) { p[k * 4 + 3] = 0; continue; }
            const kx = k % W, ky = (k / W) | 0;
            if (kx < x0) x0 = kx; if (kx > x1) x1 = kx; if (ky < y0) y0 = ky; if (ky > y1) y1 = ky;
            const b = buren(k);
            if (b) {
              const a = Math.max(0, Math.min(1, (255 - mn[k]) / 60));
              p[k * 4 + 3] = Math.round(255 * Math.min(1, (0.35 + 0.65 * a) * (1 - b / 12)));
            }
          }
          x.putImageData(d, 0, 0);
          /* bijsnijden tot het shirt zelf, zodat de kraag direct onder de hanger hangt */
          let uit = c;
          if (x1 > x0 && y1 > y0) {
            uit = document.createElement('canvas');
            uit.width = x1 - x0 + 1; uit.height = y1 - y0 + 1;
            uit.getContext('2d').drawImage(c, x0, y0, uit.width, uit.height, 0, 0, uit.width, uit.height);
          }
          uit.toBlob((blob) => {
            if (!blob) return;
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = URL.createObjectURL(blob);
            const item = img.closest('.s4-kk__item');
            if (item) item.classList.add('is-uitgeknipt');
          }, 'image/png');
        } catch (e) { /* foto niet te lezen (andere bron): de witte kaart blijft */ }
      };
      im.src = bron;
    }

    zet(r, i, stil, slepen) {
      const rek = this.rekken[r];
      const items = Array.from(rek.querySelectorAll('.s4-kk__item'));
      const n = items.length;
      if (!n) return;
      if (this.rekModus) {
        /* aan het eind van het rek weer vooraan beginnen (niet tijdens slepen) */
        if (!slepen && !stil && i > n - 1) i = 0;
        i = Math.max(0, Math.min(n - 1, i));
      } else { i = ((i % n) + n) % n; }
      this.pos[r] = i;
      this.knipRond(r, i);
      items.forEach((item, k) => {
        const off = k - i;
        const a = Math.abs(off);
        if (this.rekModus) {
          const st = this.rekStand(off);
          item.style.transform = 'translateX(' + st.x + 'px) translateZ(' + st.z + 'px) rotateY(' + st.ry + 'deg) scale(' + st.s + ')';
          item.style.opacity = String(st.o);
          item.style.display = a > 20 ? 'none' : '';   /* ver weg: niet laden */
          item.style.pointerEvents = st.o === 0 ? 'none' : '';
          item.style.zIndex = String(st.zi);
          item.style.filter = off === 0 ? '' : 'brightness(' + st.b.toFixed(2) + ')';
        } else {
          const stap = this.smal.matches ? 150 : 170;
          const tf = 'translateX(' + off * stap + 'px) translateZ(' + (a === 0 ? 120 : -a * 60) + 'px) rotateY(' + (off === 0 ? 0 : off < 0 ? 38 : -38) + 'deg)';
          item.style.transform = tf;
          const zicht = this.smal.matches ? 1 : 3;
          item.style.opacity = a > zicht ? '0' : a === 0 ? '1' : String(0.75 - a * 0.12);
          item.style.pointerEvents = a > zicht ? 'none' : '';
          item.style.zIndex = String(20 - a);
        }
        item.tabIndex = -1;
        item.setAttribute('aria-current', off === 0 ? 'true' : 'false');
      });
      const teller = rek.querySelector('[data-teller]');
      if (teller) teller.textContent = (i + 1) + ' van ' + n;
      if (!stil && r === this.actief) this.toonInfo();
    }

    toonInfo() {
      const rek = this.rekken[this.actief];
      if (!rek) return;
      const items = rek.querySelectorAll('.s4-kk__item');
      const item = items[this.pos[this.actief]];
      const zetTekst = (sel, t) => { const el = this.querySelector(sel); if (el) el.textContent = t; };
      if (!item) { zetTekst('[data-info-titel]', ''); zetTekst('[data-info-speler]', ''); return; }
      zetTekst('[data-info-titel]', item.dataset.titel || '');
      zetTekst('[data-info-speler]', item.dataset.speler || item.dataset.titel || '');
      zetTekst('[data-info-rest]', item.dataset.rest || '');
      zetTekst('[data-info-teller]', (this.pos[this.actief] + 1) + ' / ' + items.length);
      zetTekst('[data-info-seizoen]', item.dataset.seizoen || '');
      const seizoenRegel = this.querySelector('[data-info-seizoen-regel]');
      if (seizoenRegel) seizoenRegel.hidden = !item.dataset.seizoen;
      zetTekst('[data-info-prijs]', item.dataset.prijs || '');
      const lijstPrijs = item.dataset.prijsLijst || '';
      const lijstRegel = this.querySelector('[data-info-lijst-regel]');
      const lijstEl = this.querySelector('[data-info-prijs-lijst]');
      const prijsLabel = this.querySelector('[data-info-prijs-label]');
      if (lijstRegel && lijstEl) {
        lijstEl.textContent = lijstPrijs;
        lijstRegel.hidden = !lijstPrijs;
      }
      if (prijsLabel) prijsLabel.textContent = lijstPrijs ? 'Zonder lijst' : 'Prijs';
      const link = this.querySelector('[data-info-link]');
      if (link) link.href = item.dataset.url || '#';
      const label = this.querySelector('[data-info-label]');
      if (label) {
        label.replaceChildren();
        const bron = item.querySelector('[data-label] .s4-label');
        if (bron) label.appendChild(bron.cloneNode(true));
        const labelRegel = this.querySelector('[data-info-label-regel]');
        if (labelRegel) labelRegel.hidden = !bron;
      }
    }
  }

  customElements.define('s4-kleedkamer', S4Kleedkamer);
})();
